function toNumber(value: unknown): number | undefined {
    if (typeof value === "number") {
        return value;
    }
    if (typeof value === "string") {
        const parsed = Number(value);
        return Number.isNaN(parsed) ? undefined : parsed;
    }
    return undefined;
}

function toString(value: unknown): string {
    if (value == null) {
        return "";
    }
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "number") {
        return String(value);
    }
    try {
        return String(value);
    } catch {
        return "";
    }
}

function toDate(value: unknown): Date | null {
    if (value instanceof Date) {
        const time = value.getTime();
        return Number.isNaN(time) ? null : value;
    }

    if (typeof value === "string" || typeof value === "number") {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    return null;
}

function formatDate(dateInput: string | Date, timeZone?: string): string {
    const date = toDate(dateInput);
    if (!date) {
        return "";
    }

    return date.toLocaleDateString("en-AU", {
        weekday: "short",
        month: "short",
        day: "numeric",
        ...(timeZone ? { timeZone } : {}),
    });
}

function formatTimeRange(startTime: string | Date, endTime: string | Date, timeZone?: string): string {
    const start = toDate(startTime);
    const end = toDate(endTime);

    if (!start || !end) {
        return "";
    }

    const formatTime = (date: Date) => {
        return date.toLocaleTimeString("en-AU", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
            ...(timeZone ? { timeZone } : {}),
        });
    };

    return `${formatTime(start)} - ${formatTime(end)}`;
}

function formatListedOnDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());
    return `${day}/${month}/${year}`;
}

export const propertyDetailsUtils = {
    toNumber,
    toString,
    toDate,
    formatDate,
    formatTimeRange,
    formatListedOnDate,
};
